export default "/assets/images/dust-video.mp4?137ac75742a7e0c1e1bfa5608f14a5b8";